import { render, staticRenderFns } from "./search-course-modal.vue?vue&type=template&id=7a6378ae&scoped=true&"
import script from "./search-course-modal.vue?vue&type=script&lang=js&"
export * from "./search-course-modal.vue?vue&type=script&lang=js&"
import style0 from "./search-course-modal.vue?vue&type=style&index=0&id=7a6378ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6378ae",
  null
  
)

export default component.exports